import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { decisionsQueryKey } from "../decisioning.keys";

const parseDecisions = (data: unknown) =>
	Dtos.Decisioning.Decision.Get.Response.schema.array().parse(data);

export const useFetchAdminDecisions = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: decisionsQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			parseDecisions(await get<unknown>(`/v2/admin/surety/accounts/${accountId}/decisions`)),
	});

	return {
		decisions: query.data,
		decisionsIsLoading: query.isLoading,
		decisionsError: query.error,
		refetchDecisions: query.refetch,
	};
};
